/**
 * DataSpecialistRouter - Feature Flag Aware Routing for Data Specialist Pages
 * 
 * When UNIFIED_WORK_QUEUE is enabled:
 * - /queue/data-specialist redirects to /queue
 * - /review-queue redirects to /queue?tab=transactions
 * - /issues redirects to /queue?tab=issues
 * 
 * When disabled:
 * - Old routes work as before
 */

import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';
import DataSpecialistQueue from '../../pages/DataSpecialistQueue';
import TransactionReviewQueue from '../../pages/TransactionReviewQueue';
import IssueTrackerDashboard from '../../pages/IssueTrackerDashboard';
import UnifiedWorkQueue from '../../pages/UnifiedWorkQueue';

/**
 * Data Specialist Queue Router
 * Routes /queue/data-specialist to either legacy or unified
 */
export function DataSpecialistQueueRouter() {
  const useUnified = useFeatureFlag('UNIFIED_WORK_QUEUE');
  
  if (useUnified) {
    return <Navigate to="/queue" replace />;
  }
  
  return <DataSpecialistQueue />;
}

/**
 * Transaction Review Queue Router
 * Routes /review-queue to either legacy or unified (transactions tab)
 */
export function TransactionReviewRouter() {
  const useUnified = useFeatureFlag('UNIFIED_WORK_QUEUE');
  
  if (useUnified) {
    return <Navigate to="/queue?tab=transactions" replace />;
  }
  
  return <TransactionReviewQueue />;
}

/**
 * Issue Tracker Router
 * Routes /issues to either legacy or unified (issues tab)
 */
export function IssueTrackerRouter() {
  const useUnified = useFeatureFlag('UNIFIED_WORK_QUEUE');
  
  if (useUnified) {
    return <Navigate to="/queue?tab=issues" replace />;
  }
  
  return <IssueTrackerDashboard />;
}

/**
 * Unified Queue Router
 * This is the main unified queue page
 */
export function UnifiedQueueRouter() {
  return <UnifiedWorkQueue />;
}

export default {
  DataSpecialistQueueRouter,
  TransactionReviewRouter,
  IssueTrackerRouter,
  UnifiedQueueRouter,
};
